import * as actionTypes from './actionTypes';

export const setType=(type)=>{
      return {
            type:actionTypes.SET_TYPE,
            payload:type
      }
}